import React, { useRef, useCallback, useEffect } from 'react';

const CabinetCalculator = () => {
  const iframeRef = useRef(null);

  const resizeIframe = useCallback(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    try {
      const doc = iframe.contentDocument || iframe.contentWindow?.document;
      if (!doc?.body) return;

      const height = Math.max(
        doc.body.scrollHeight,
        doc.documentElement?.scrollHeight || 0
      );
      iframe.style.height = `${height}px`;
    } catch (e) {
      // same-origin only
    }
  }, []);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    let observer;

    const onLoad = () => {
      resizeIframe();

      try {
        const doc = iframe.contentDocument || iframe.contentWindow?.document;
        if (!doc?.body) return;

        observer = new MutationObserver(resizeIframe);
        observer.observe(doc.body, {
          childList: true,
          subtree: true,
          attributes: true,
        });
      } catch (e) {
        // ignore
      }
    };

    iframe.addEventListener('load', onLoad);
    window.addEventListener('resize', resizeIframe);

    return () => {
      iframe.removeEventListener('load', onLoad);
      window.removeEventListener('resize', resizeIframe);
      observer?.disconnect();
    };
  }, [resizeIframe]);

  return (
    <div className="w-full">
      <iframe
        ref={iframeRef}
        title="櫥櫃餘料極小化試算"
        src={`${process.env.PUBLIC_URL}/cabinet-calculator.html`}
        className="w-full border-0 block"
        scrolling="no"
        style={{ height: '0px', overflow: 'hidden' }}
      />
    </div>
  );
};

export default CabinetCalculator;
